export enum CHARTS_COLUMN {
  HS_CLASS = 'HS Class',
  DIVISION = 'Division',
  TEAM_SELECT = 'Team Select',
  SEC = 'SEC',
  NFL_DRAFT = 'NFL Draft',
  TEAM_SELECT_NFL = 'Team Select NFL',
  NFL_UDFA = 'NFL UDFA',
  TRANSFER_PORTAL = 'Transfer Portal',
  TEAM_SELECT_STARTER = 'TeamSelect Starter',
  CONFERENCE_STARTER = 'Conference Starter',
  ALL_CONFERENCE = 'All-Conference',
  ALL_AMERICAN = 'All-American',
  // NFL
  PRO_BOWL = 'NFL Pro-Bowl',
  ALL_PRO = 'NFL All-Pro',

}


export const PLAYER_CHARTS_COLUMNS = {
  [CHARTS_COLUMN.HS_CLASS]: 'HS Class',
  [CHARTS_COLUMN.DIVISION]: 'Division',
  [CHARTS_COLUMN.TEAM_SELECT]: 'Team Select',
  [CHARTS_COLUMN.SEC]: 'SEC',
  [CHARTS_COLUMN.NFL_DRAFT]: 'NFL Draft',
  [CHARTS_COLUMN.TEAM_SELECT_NFL]: 'Team Select NFL',
  [CHARTS_COLUMN.NFL_UDFA]: 'NFL UDFA',
  [CHARTS_COLUMN.TRANSFER_PORTAL]: 'Transfer Portal',
  [CHARTS_COLUMN.TEAM_SELECT_STARTER]: 'TeamSelect Starter',
  [CHARTS_COLUMN.CONFERENCE_STARTER]: 'Conference Starter',
  [CHARTS_COLUMN.ALL_CONFERENCE]: 'All-Conference',
  [CHARTS_COLUMN.ALL_AMERICAN]: 'All-American',
  [CHARTS_COLUMN.PRO_BOWL]: 'NFL Pro-Bowl',
  [CHARTS_COLUMN.ALL_PRO]: 'NFL All-Pro',
}

export const PLAYER_CHARTS_ALL_COLUMNS = [
  CHARTS_COLUMN.HS_CLASS,
  CHARTS_COLUMN.DIVISION,
  CHARTS_COLUMN.TEAM_SELECT,
  CHARTS_COLUMN.SEC,
  CHARTS_COLUMN.NFL_DRAFT,
  CHARTS_COLUMN.TEAM_SELECT_NFL,
  CHARTS_COLUMN.NFL_UDFA,
  CHARTS_COLUMN.TRANSFER_PORTAL,
  CHARTS_COLUMN.TEAM_SELECT_STARTER,
  CHARTS_COLUMN.CONFERENCE_STARTER,
  CHARTS_COLUMN.ALL_CONFERENCE,
  CHARTS_COLUMN.ALL_AMERICAN,
  CHARTS_COLUMN.PRO_BOWL,
  CHARTS_COLUMN.ALL_PRO,
]